namespace BuildProperties {
	// autoupdates from Gruntfile.js 
	// значения костант в этом файле подставляются перед билдом
	// поддерживаются только строки
	// после каждого билда значения будут заменены на пустые строки
	export const srcRevision:string = "8c4c4b0fa91674a3acc342e19232ebbe5a63dea1 (jam) tip"; // hg id --debug
	export const buildDate:string = "1499673616481"; // Date.now()
	export const resourcePath:string = "http://flashjs.dev.crazypanda.ru/s/";
	export const as3FilesPath:string = "C:/projects/builderWorkspace/TranslationTests/src/tests";
	export const convertedFilesPath:string = "C:/projects/pandajs3d/webGl_benchmark/src/apps/as3tsTests/converted";
	export const predefinedPath:string = "C:/projects/pandajs3d/webGl_benchmark/src/apps/predefined";
	export const tmpPath:string = "c:/projects/pandajs3d/webGl_benchmark/tmp";
	export const online:string = "true";
}